module.exports = __webpack_public_path__ + "img/bsty2.5cc422d5.jpg";